import { theme } from 'Assets/Styles/theme'

export default {
  countryCardWrapper: {
    border: '1px solid rgba(0, 0, 0, 0.2)',
    boxShadow: 'none !important',
    borderRadius: '5px !important',
  },

  countryName: {
    color: theme.colors.oxfordBlue,
    lineHeight: '18px !important',
    fontSize: '16px !important',
    display: 'flex',
    justifyContent: 'flex-start',
  },
  countryLink: {
    '&:hover': {
      textDecoration: 'none',
    },
  },
}
